import React from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { articles, articleBody } from '../mock';

const ArticleDetail = () => {
  const { slug } = useParams();
  const a = articles.find(x => x.slug === slug);
  if (!a) return <Navigate to="/articles" replace />;
  const related = articles.filter(x => x.slug !== slug).slice(0, 3);

  return (
    <div className="fade-in">
      <article className="pt-20 pb-16">
        <div className="max-w-3xl mx-auto px-6">
          <Link to="/articles" className="inline-flex items-center gap-1.5 text-[13px] text-slate-500 hover:text-[#1F3864] mb-6"><ArrowLeft size={14} /> Back to Articles</Link>
          <div className="flex items-center gap-3 text-[12px] uppercase tracking-widest text-slate-500 mb-4">
            <span className="text-[#1F3864] font-semibold">{a.category}</span>
            <span className="text-slate-300">|</span>
            <span>{a.date}</span>
          </div>
          <h1 className="font-serif-display text-4xl md:text-5xl leading-[1.1] text-[#1F3864] tracking-tight">{a.title}</h1>
          <p className="mt-6 text-[19px] text-slate-700 leading-relaxed italic">{a.excerpt}</p>
          <div className="rule-navy my-10" />
          <div className="space-y-6 text-[17px] leading-[1.85] text-slate-700">
            {articleBody.map((p) => <p key={p.slice(0, 40)}>{p}</p>)}
          </div>
          <div className="mt-12 pt-10 border-t border-slate-200">
            <Link to="/contact" className="inline-flex items-center gap-2 bg-[#1F3864] text-white text-[15px] font-medium px-6 py-3.5 rounded-sm hover:bg-[#17294a] transition-colors">
              Request a Consultation <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </article>

      <section className="bg-slate-50 border-t border-slate-200 py-16">
        <div className="max-w-6xl mx-auto px-6">
          <div className="font-serif-display text-2xl text-[#1F3864] mb-8">Continue Reading</div>
          <div className="grid md:grid-cols-3 gap-6">
            {related.map(r => (
              <Link key={r.slug} to={`/articles/${r.slug}`} className="card-hover block bg-white border border-slate-200 rounded-sm p-6">
                <div className="text-[12px] uppercase tracking-widest text-[#1F3864] font-semibold mb-2">{r.category}</div>
                <div className="font-serif-display text-[18px] text-[#1F3864] leading-snug">{r.title}</div>
                <div className="mt-3 text-[12px] text-slate-500">{r.date}</div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ArticleDetail;
